export default __webpack_public_path__ + "static/media/architecture-img-17.6f6eec8c.jpg";